<template>
  <b-container fluid>
    <b-row v-if="!project_data_loading">
      <b-col md="12" class="p-4">
        <b-row>
          <!-- <b-col cols="12">
            <fieldset class="form-group border p-3">
              <legend class="w-auto px-2 text-primary">Project</legend>
              <b-row>
                <b-col lg="6">
                  <b-form-group label-for="dateIssued" label="Projects">
                    <span>
                      {{ projectData?.project_sub?.project?.project_name }} -
                      {{ projectData?.project_sub?.name }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Customer" label-for="customer_id">
                    <span>
                      {{ projectData?.customer?.customer_code }} -
                      {{ projectData?.customer?.account_name }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </fieldset>
          </b-col> -->

          <!-- DETAIL PROJECT CONTRACT -->
          <b-col lg="12" class="mb-4">
            <b-row>
              <b-col :lg="'12'">
                <div class="section-title mb-4">
                  <h5>Project Info</h5>
                </div>
                <b-row class="mb-3">
                  <!-- Company Name -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Company Name
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{ projectData?.customer?.account_name }}
                      </strong>
                    </div>
                  </b-col>
                  <!-- Port of Loading -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Port of Loading
                      </span>
                      <span class="mr-2">:</span>
                      <div class="d-flex flex-column">
                        <strong
                          v-for="(polObj, polIndex) in projectData?.pol"
                          :key="polIndex"
                        >
                          {{ polObj?.value ?? '-' }}
                        </strong>
                      </div>
                    </div>
                  </b-col>

                  <!-- Fleet Ownership -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Fleet Ownership
                      </span>
                      <span class="mr-2">:</span>
                      <b-badge
                        class="border border-dark text-dark text-uppercase font-weight-bold"
                        variant="none"
                      >
                        {{
                          projectData?.fleet_ownership === 'own-ship'
                            ? 'Own Ship'
                            : 'Chartered'
                        }}
                      </b-badge>
                    </div>
                  </b-col>
                  <!-- Port of Discharging -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Port of Discharging
                      </span>
                      <span class="mr-2">:</span>
                      <div class="d-flex flex-column">
                        <strong
                          v-for="(podObj, podIndex) in projectData?.pod"
                          :key="podIndex"
                        >
                          {{ podObj?.value ?? '-' }}
                        </strong>
                      </div>
                    </div>
                  </b-col>

                  <!-- Fleet Type -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Fleet Type
                      </span>
                      <span class="mr-2">:</span>
                      <div class="d-flex flex-wrap">
                        <b-badge
                          class="border border-dark text-dark text-uppercase mr-1 font-weight-bold"
                          style="height: max-content"
                          variant="none"
                        >
                          Tugboat
                        </b-badge>
                      </div>
                    </div>
                  </b-col>

                  <!-- Distance -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Distance
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{ projectData?.distance?.toLocaleString() }} NM
                      </strong>
                    </div>
                  </b-col>

                  <!-- Period -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Period
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{
                          projectData?.periode_start
                            ? $moment(projectData?.periode_start).format(
                                'DD/MM/YYYY'
                              )
                            : '-'
                        }}
                        -
                        {{
                          projectData?.periode_end
                            ? $moment(projectData?.periode_end).format(
                                'DD/MM/YYYY'
                              )
                            : '-'
                        }}
                      </strong>
                    </div>
                  </b-col>

                  <!-- Laycan -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Laycan
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{
                          projectData?.laycan_start
                            ? $moment(projectData?.laycan_start).format(
                                'DD MMMM YYYY'
                              )
                            : '-'
                        }}
                        -
                        {{
                          projectData?.laycan_end
                            ? $moment(projectData?.laycan_end).format(
                                'DD MMMM YYYY'
                              )
                            : '-'
                        }}
                      </strong>
                    </div>
                  </b-col>

                  <!-- Shipment Plan Number -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Shipment Plan Number
                      </span>
                      <span class="mr-2">:</span>
                      <strong>{{ projectData?.shipment_plan_number }}</strong>
                    </div>
                  </b-col>
                  <!-- Cargo Type -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Cargo Type
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{ projectData?.cargo_type?.name ?? 'COAL' }}
                      </strong>
                    </div>
                  </b-col>

                  <!-- Contract Type -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Contract Type
                      </span>
                      <span class="mr-2">:</span>
                      <div>
                        <strong>
                          {{ projectData?.contract_type?.name }}
                        </strong>
                        <br />
                        <b-alert
                          :show="
                            projectData?.contract_type?.name ===
                            'Spot Freight Charter'
                          "
                          class="d-flex align-items-center p-2"
                        >
                          <i class="fas fa-info-circle text-primary"></i>
                          <small class="text-muted ml-1">
                            This type using SPAL
                          </small>
                        </b-alert>
                      </div>
                    </div>
                  </b-col>
                  <!-- Total Plan QTY -->
                  <b-col md="6" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Total Plan QTY
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{
                          projectData?.total_quantity?.toLocaleString() ??
                          '10.000'
                        }}
                        {{ projectData?.unit ?? 'MT' }}
                      </strong>
                    </div>
                  </b-col>

                  <!-- Term -->
                  <b-col md="12" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Term
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{
                          projectData?.terms?.name ??
                          '7 D (Payment 7 Days After Invoice Send)'
                        }}
                      </strong>
                    </div>
                  </b-col>

                  <!-- Remarks -->
                  <b-col md="12" class="mb-3">
                    <div class="d-flex">
                      <span class="text-muted mr-2" style="width: 300px">
                        Remarks
                      </span>
                      <span class="mr-2">:</span>
                      <strong>
                        {{
                          projectData?.remarks ??
                          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                        }}
                      </strong>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <b-col lg="12" class="mb-5">
            <div class="section-title mb-4">
              <h5>Detail Shipment Plan</h5>
            </div>
            <div class="d-flex overflow-auto" style="max-height: 500px">
              <table class="table table-bordered">
                <thead class="thead-light">
                  <tr class="sticky-header text-black">
                    <th class="text-center text-black">#</th>
                    <th class="text-truncate text-black">Number Detail Plan</th>
                    <th class="text-truncate text-black">Fleet</th>
                    <th class="text-truncate text-black">Cargo Type</th>
                    <th class="text-truncate text-black">Plan Quantity</th>
                    <th class="text-truncate text-black">Status</th>
                    <th class="text-truncate text-black text-center">Description</th>
                    <th class="text-truncate text-black text-center">Remarks</th>
                  </tr>
                </thead>
                <tbody v-if="projectData?.project_contract_plan?.length > 0">
                  <tr
                    v-for="(val, index) in projectData?.project_contract_plan"
                    :key="index"
                  >
                    <td class="text-center">
                      <b-form-checkbox
                        name="checked"
                        v-model="val.checked"
                        @change="onCheckedPlan(index)"
                        :disabled="val.disabled"
                      ></b-form-checkbox>
                    </td>
                    <td class="text-truncate">
                      {{ val?.shipment_plan_detail_number }}
                    </td>
                    <td class="text-truncate">
                      <div class="d-flex w-100">
                        <b-badge
                          class="border border-primary text-primary text-uppercase mr-1"
                          variant="none"
                          v-for="(obj, objIndex) in val?.fleets"
                          :key="objIndex"
                        >
                          {{ showVehicleName(obj.vehicle_id) }}
                        </b-badge>
                      </div>
                    </td>
                    <td class="text-truncate">{{ val?.cargo_type?.name }}</td>
                    <!-- <td class="text-truncate">-</td>
                    <td class="text-truncate">-</td> -->
                    <td class="text-truncate">
                      {{ val?.plan_quantity?.toLocaleString() }} {{ projectData?.unit }}
                    </td>
                    <td class="text-truncate text-capitalize">
                      {{ val?.status }}
                    </td>
                    <td class="text-truncate text-center" style="max-width: 200px">
                      <b-button
                        variant="primary"
                        @click="showDescriptionModal(val?.description)"
                        size="sm"
                      >
                        Description
                      </b-button>
                    </td>
                    <td class="text-truncate text-center" style="max-width: 200px">
                      <b-button
                        variant="primary"
                        @click="showRemarksModal(val?.remarks)"
                        size="sm"
                      >
                        Remark
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>

          <!-- OPERATIONAL DATA -->
          <b-col md="12">
            <div class="section-title mb-4">
              <h5>Fleet Operational</h5>
            </div>
            <b-row>
              <b-col md="12" class="d-flex mb-3">
                <date-picker
                  v-model="dateRange"
                  type="date"
                  range
                  placeholder="Select date range"
                  class="mr-2"
                  :style="{ width: '240px' }"
                ></date-picker>
                <v-select
                  label="text"
                  name="vehicle_id"
                  :style="{ width: '200px' }"
                  v-model="params.vehicle_id"
                  :options="optionsFleets"
                  :reduce="(optionsFleets) => optionsFleets.value"
                  placeholder="Select Fleet"
                ></v-select>
              </b-col>
              <b-col md="12">
                <div class="table-responsive">
                  <table class="table">
                    <thead class="thead-light">
                      <!-- Header Group -->
                      <tr>
                        <!-- Fixed Columns -->
                        <th
                          v-for="(col, index) in fixedColumns"
                          :key="index"
                          rowspan="2"
                          class="text-center text-black text-truncate align-middle sticky-column"
                          :class="{
                            'sticky-column-1': index === 0,
                            'sticky-column-2': index === 1,
                          }"
                        >
                          {{ col.title }}
                        </th>

                        <!-- Port of Loading Group Header -->
                        <th
                          :colspan="portOfLoadingColumns.length"
                          class="bg-primary-custom text-center text-white"
                        >
                          Port of Loading
                        </th>

                        <!-- Port of Discharge Group Header -->
                        <th
                          :colspan="portOfDischargeColumns.length"
                          class="bg-warning-custom text-center text-white"
                        >
                          Port of Discharge
                        </th>
                      </tr>

                      <!-- Sub Header -->
                      <tr>
                        <!-- Port of Loading Columns -->
                        <th
                          v-for="(col, index) in portOfLoadingColumns"
                          :key="`pol-${index}`"
                          class="bg-primary-custom text-truncate text-white"
                        >
                          {{ col }}
                        </th>

                        <!-- Port of Discharge Columns -->
                        <th
                          v-for="(col, index) in portOfDischargeColumns"
                          :key="`pod-${index}`"
                          class="bg-warning-custom text-truncate text-white"
                        >
                          {{ col }}
                        </th>
                      </tr>
                    </thead>

                    <tbody v-if="listTrips?.length > 0">
                      <tr v-for="(val, index) in listTrips" :key="index">
                        <td
                          class="text-center sticky-column sticky-column-1 bg-white"
                        >
                          <b-form-checkbox
                            name="checked"
                            class="d-flex justify-content-center"
                            v-model="val.checked"
                            @change="onCheckedTrips(index)"
                            :disabled="val.disabled"
                          ></b-form-checkbox>
                        </td>
                        <td
                          class="text-truncate sticky-column sticky-column-2 bg-white"
                        >
                          <div class="d-flex w-100">
                            <b-badge
                              class="border border-primary text-primary text-uppercase mr-1"
                              variant="none"
                              v-for="(obj, objIndex) in val?.vehicle"
                              :key="objIndex"
                            >
                              {{ obj?.name }}
                            </b-badge>
                          </div>
                        </td>
                        <td class="text-truncate">
                          {{ val?.tripRecord?.status }}
                        </td>
                        <td class="text-truncate">
                          {{ val?.tripRecord?.cargoType }}
                        </td>
                        <td class="text-truncate">
                          {{
                            Number(
                              val?.tripRecord?.cargoUnloading
                            )?.toLocaleString()
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            Number(
                              val?.tripRecord?.cargoLoading
                            )?.toLocaleString()
                          }}
                        </td>

                        <!-- POD DATA -->
                        <td class="text-truncate">
                          {{ val?.tripRecord?.agentPol || '-' }}
                        </td>
                        <td class="text-truncate">
                          {{ val?.tripRecord?.portLoading?.portName || '-' }}
                        </td>
                        <td class="text-truncate text-center">
                          {{
                            val?.tripRecord?.polBlDate
                              ? moment(
                                  val?.tripRecord?.polBlDate,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate text-center">
                          {{
                            val?.tripRecord?.polNor
                              ? moment(
                                  val?.tripRecord?.polNor,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate text-center">
                          {{
                            val?.tripRecord?.polNoa
                              ? moment(
                                  val?.tripRecord?.polNoa,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polAnchorUp
                              ? moment(
                                  val?.tripRecord?.polAnchorUp,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polBerthing
                              ? moment(
                                  val?.tripRecord?.polBerthing,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polCommenced
                              ? moment(
                                  val?.tripRecord?.polCommenced,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polCompleted
                              ? moment(
                                  val?.tripRecord?.polCompleted,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate text-center">
                          {{
                            Number(
                              val?.tripRecord?.polDraughtSurvey
                            )?.toLocaleString() ?? 0
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polCastIn
                              ? moment(
                                  val?.tripRecord?.polCastIn,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polCastOut
                              ? moment(
                                  val?.tripRecord?.polCastOut,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polLhv
                              ? moment(
                                  val?.tripRecord?.polLhv,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polDocOnBoard
                              ? moment(
                                  val?.tripRecord?.polDocOnBoard,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.polDeparture
                              ? moment(
                                  val?.tripRecord?.polDeparture,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td
                          class="text-truncate text-center"
                          style="max-width: 250px"
                        >
                          {{ val?.tripRecord?.polRemark }}
                        </td>

                        <!-- POD DATA -->
                        <td class="text-truncate">
                          {{ val?.tripRecord?.agentPod || '-' }}
                        </td>
                        <td class="text-truncate">
                          {{ val?.tripRecord?.portDischarge?.portName || '-' }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podArrivalTime
                              ? moment(
                                  val?.tripRecord?.podArrivalTime,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate text-center">
                          {{
                            val?.tripRecord?.podNor
                              ? moment(
                                  val?.tripRecord?.podNor,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate text-center">
                          {{
                            val?.tripRecord?.podNoa
                              ? moment(
                                  val?.tripRecord?.podNoa,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podAnchorUp
                              ? moment(
                                  val?.tripRecord?.podAnchorUp,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podBerthing
                              ? moment(
                                  val?.tripRecord?.podBerthing,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podCommenced
                              ? moment(
                                  val?.tripRecord?.podCommenced,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podCompleted
                              ? moment(
                                  val?.tripRecord?.podCompleted,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate text-center">
                          {{
                            Number(
                              val?.tripRecord?.podDraughtSurvey
                            ).toLocaleString() ?? 0
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podCastIn
                              ? moment(
                                  val?.tripRecord?.podCastIn,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podCastOut
                              ? moment(
                                  val?.tripRecord?.podCastOut,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td class="text-truncate">
                          {{
                            val?.tripRecord?.podDeparture
                              ? moment(
                                  val?.tripRecord?.podDeparture,
                                  'DD-MM-YYYY HH:mm'
                                ).format('DD MMM YYYY HH:mm')
                              : '-'
                          }}
                        </td>
                        <td
                          class="text-truncate text-center"
                          style="max-width: 250px"
                        >
                          {{ val?.tripRecord?.polRemark }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="d-flex align-items-center justify-content-center w-100 my-2 mb-4"
                  v-if="listTrips?.length <= 0"
                >
                  <strong class="text-muted">
                    No data found. Select other plan.
                  </strong>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="12" class="mb-4 mt-0">
        <div class="d-flex align-items-center justify-content-center">
          <b-button
            variant="outline-primary"
            class="w-50 mr-2"
            type="button"
            @click="closeSlideFormRealShipment"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="w-50"
            type="submit"
            @click.prevent="onSubmit"
          >
            Submit
          </b-button>
        </div>
      </b-col>
    </b-row>

    <div v-else class="alert alert-info m-4">Loading...</div>

    <!-- Description Modal -->
    <b-modal
      id="description-modal"
      ref="descriptionModal"
      title="Description"
      ok-only
      ok-title="Close"
    >
      <div class="p-3">
        <p class="text-wrap">{{ modalContent }}</p>
      </div>
    </b-modal>

    <!-- Remarks Modal -->
    <b-modal
      id="remarks-modal"
      ref="remarksModal"
      title="Remarks"
      ok-only
      ok-title="Close"
    >
      <div class="p-3">
        <p class="text-wrap">{{ modalContent }}</p>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { busdevActions, voyagesActions } from '@src/Utils/helper'

export default {
  name: 'SlideFormRealShipment',
  props: {
    action: {
      type: String,
      default: '',
    },
    projectId: {
      type: Number,
      default: null,
    },
    detailRealShipment: {
      type: Object,
      default: null,
    },
    refreshData: {
      type: Function,
      default: () => {},
    },
    showVehicleName: {
      type: Function,
      default: () => {},
    },
    optionsFleets: {
      type: Array,
      default: () => [],
    },
    closeSlideFormRealShipment: {
      type: Function,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      project_data_loading: false,

      projectData: null,

      listTrips: [],

      dateRange: [
        new Date(moment().startOf('year')),
        new Date(moment().endOf('year')),
      ],
      params: {
        vehicle_id: null,
      },

      modalContent: '', // For storing content to display in modals

      // Table column definitions
      fixedColumns: [
        {
          title: '#',
          style: 'width: 5px; background-color: #e0dde4',
        },
        {
          title: 'FLEET',
          style: 'background-color: #E0DDE4',
        },
        {
          title: 'STATUS',
          style: 'background-color: #E0DDE4',
        },
        {
          title: 'CARGO TYPE',
          style: 'background-color: #E0DDE4',
        },
        {
          title: 'CARGO UNLOADING',
          style: 'background-color: #E0DDE4',
        },
        {
          title: 'CARGO LOADING',
          style: 'background-color: #E0DDE4',
        },
      ],

      portOfLoadingColumns: [
        'POL',
        'Agent POL',
        'BL Date',
        'NOR',
        'NOA',
        'Anchor Up',
        'In Position / Berthing',
        'Commenced',
        'Completed',
        'Draught Survey',
        'Second Berthing',
        'Cast Out',
        'LHV',
        'Document on Board',
        'Departure to POD',
        'Remarks',
      ],

      portOfDischargeColumns: [
        'POD',
        'Agent POD',
        'Arrival Time POD',
        'NOR',
        'NOA',
        'Anchor Up',
        'In Position / Berthing',
        'Commenced',
        'Completed',
        'Draught Survey',
        'Second Berthing',
        'Cast Out',
        'Departure to POL',
        'Remarks',
      ],
    }
  },
  watch: {
    action: {
      deep: true,
      handler: async function (value) {
        if (value === 'ADD') {
          console.log('action add', value)
          this.resetForm()
          await this.getProjectData(this.projectId)
          await this.fetchVoyageByTrips()
        } else {
          await this.getProjectData(this.projectId)
          await this.fetchVoyageByTrips()
        }
      },
      immediate: true,
    },
    projectId: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (value) {
          this.getProjectData(value)
        }
      },
    },
    'params.vehicle_id': {
      handler: async function (newValue, oldValue) {
        console.log('Fleet changed from', oldValue, 'to', newValue)
        if (newValue && newValue !== oldValue) {
          await this.fetchVoyageByTrips()
        }
      },
      immediate: false,
    },
    dateRange: {
      deep: true,
      handler: async function (newValue, oldValue) {
        console.log('Date range changed:', newValue)
        if (this.params.vehicle_id && newValue && newValue !== oldValue) {
          await this.fetchVoyageByTrips()
        }
      },
      immediate: false,
    },
  },
  async mounted() {},
  // computed:{
  //   totalQuantityAdd() {
  //     return this.projectData?.detail_plan?.reduce((total, item) => total + Number(item?.plan_quantity), 0);
  //   },
  // },
  methods: {
    ...voyagesActions,
    ...busdevActions,
    showVehicleName(value) {
      let vehicle = this.optionsFleets.find((obj) => obj.value == value)

      return vehicle?.text ?? '-'
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },

    resetForm() {
      // this.project_data_loading = false,
      // this.projectData = null,
      // this.listTrips = [],
      // this.dateRange = [new Date(moment().startOf('year')), new Date(moment().endOf('year'))],
      // this.params = {
      //   vehicle_id: null
      // }
    },

    async onCheckedPlan(selectedIndex) {
      this.projectData.project_contract_plan.forEach((row, i) => {
        row.checked = i === selectedIndex
      })
      let checkedPlan = this.projectData?.project_contract_plan?.find(
        (obj) => obj?.checked
      )

      if (checkedPlan) {
        this.params.vehicle_id = checkedPlan?.fleets?.[0]?.vehicle_id
        await this.fetchVoyageByTrips()
      }
    },

    onCheckedTrips(selectedIndex) {
      this.listTrips.forEach((row, i) => {
        row.checked = i === selectedIndex
      })
    },

    // FETCHING DATA EDIT & DETAIL PLAN
    async getProjectData(id) {
      this.project_data_loading = true

      let res = await this.fetchDetailProjectContractWithoutPFA({ id })

      if (res.data.status === true) {
        this.projectData = res.data.data

        if (this.projectData.project_contract_plan?.length > 0) {
          this.projectData.project_contract_plan =
            this.projectData.project_contract_plan?.map((obj) => {
              return {
                ...obj,
                checked:
                  this.detailRealShipment?.project_plan_id === obj.id
                    ? true
                    : false,
                // disabled: this.detailRealShipment?.project_plan_id === obj.id ? true : false
              }
            })
        }

        this.params.vehicle_id =
          this.detailRealShipment?.vehicle_id ??
          this.projectData?.project_contract_plan?.find((obj) => obj?.checked)
            ?.fleets?.[0]?.vehicle_id ??
          null
      } else {
        this.projectData = null
      }
      this.project_data_loading = false
    },

    async fetchVoyageByTrips() {
      console.log('Fetching voyage data...', {
        vehicle_id: this.params.vehicle_id,
        dateRange: this.dateRange,
      })

      if (!this.params.vehicle_id) {
        console.log('No vehicle selected')
        this.listTrips = []
        return
      }

      let params = {
        page: 1,
        perPage: 500000000,
        vehicleId: Number(this.params.vehicle_id),
        startDate: this.dateRange?.[0]
          ? moment(this.dateRange?.[0]).format('DD-MM-YYYY')
          : null,
        endDate: this.dateRange?.[1]
          ? moment(this.dateRange?.[1]).format('DD-MM-YYYY')
          : null,
      }

      // Remove null or empty values
      Object.keys(params).forEach((key) => {
        if (
          params[key] === null ||
          params[key] === '' ||
          params[key] === undefined
        ) {
          delete params[key]
        }
      })

      console.log('API params:', params)

      try {
        const res = await this.getVoyageTrips(params)
        console.log('API response:', res)

        if (res.status === true || res.status === 'success') {
          this.listTrips =
            res.data?.data?.map((val) => {
              return {
                ...val,
                checked:
                  this.detailRealShipment?.trip_id === val?.tripRecord?.id
                    ? true
                    : false,
              }
            }) || []
          console.log('Trips loaded:', this.listTrips.length)
        } else {
          console.log('API returned error:', res.message || 'Unknown error')
          this.listTrips = []
        }
      } catch (error) {
        console.error('Error fetching voyage trips:', error)
        this.listTrips = []
      }
    },

    showDescriptionModal(description) {
      this.modalContent = description || 'No description available'
      this.$refs.descriptionModal.show()
    },

    showRemarksModal(remarks) {
      this.modalContent = remarks || 'No remarks available'
      this.$refs.remarksModal.show()
    },

    async onSubmit() {
      let checkedPlan = this.projectData?.project_contract_plan?.find(
        (obj) => obj?.checked
      )
      let checkedTrip = this.listTrips?.find((obj) => obj?.checked)

      if (!checkedPlan || !checkedTrip)
        return this.$swal(
          `Plan & Trip Required!`,
          'Choose Plan & Trip first.',
          'warning'
        )

      let payload = {
        project_contract_id: this.projectData?.id,
        project_plan_id: checkedPlan?.id,
        trip_id: checkedTrip?.tripRecord?.id,
        vehicle_id: this.params?.vehicle_id,
      }

      const res = await this.saveRealShipment({ data: payload })

      if (res.status == 'success') {
        this.refreshData()
        this.$swal('Success!', 'Real Shipment Saved.', 'success')
        this.closeSlideFormRealShipment()
      } else {
        this.$swal(
          `Oops!`,
          res?.data?.message ?? 'Something went wrong.',
          'error'
        )
      }
    },
  },
}
</script>

<style scoped>
.sticky-header {
  position: sticky;
  top: 0;
  /* background-color: white; */
  z-index: 1;
}
.section-title {
  position: relative;
  width: 100%;
  border-bottom: 2px solid #334697;
  background: blue;
  margin-bottom: 20px;
}

.section-title h5 {
  color: #273469;
  font-weight: 600;
  background: white;
  position: absolute;
  top: -14px;
  padding-right: 20px;
  font-size: 20px;
}

.bg-primary-custom {
  background-color: #334697 !important;
  color: #ffffff !important;
}
.bg-warning-custom {
  background-color: #ffa500 !important;
  color: #ffffff !important;
}
.bg-slate-custom {
  background-color: #e0dde4 !important;
  color: black !important;
}

/* Sticky Column Styles */
.sticky-column {
  position: sticky;
  z-index: 10;
}

.sticky-column-1 {
  left: 0;
  min-width: 50px;
  max-width: 50px;
  width: 50px;
  z-index: 12;
}

.sticky-column-2 {
  left: 50px;
  min-width: 120px;
  z-index: 11;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
}

/* Ensure sticky headers have higher z-index */
.sticky-header .sticky-column {
  z-index: 15;
}

.sticky-header .sticky-column-1 {
  z-index: 17;
}

.sticky-header .sticky-column-2 {
  z-index: 16;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
}

/* Cursor pointer for clickable cells */
.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}
</style>
